/**
 * For each PRODUCT URL in the incoming sitemap list, generate and inject
 * its related CATEGORY_HUB entries, avoiding duplicates.
 */
import ISitemapUrl from '@/interfaces/IUrl';
import Provider from '@/enums/Provider';
import UrlTypes from '@/enums/UrlTypes';
import { getCategoryHubUrls } from './getCategoryHubUrls';

/**
 * Append category-hub URLs for each product URL in the list.
 * @param urls - the initial array of sitemap URL objects
 * @param provider - the provider context for determining hubs
 * @returns A new array including original URLs + any injected hubs
 */
export function appendCategoryHubs(
    urls: ISitemapUrl[],
    provider: Provider
): ISitemapUrl[] {
    // copy original to avoid mutating input
    const output = [...urls];

    // Only process URLs flagged as PRODUCT pages
    urls
        .filter(u => u.urlType === UrlTypes.PRODUCT)
        .forEach(prod => {
            // generate hub URLs for this product path
            const hubs = getCategoryHubUrls(provider, prod.pathname);
            hubs.forEach(hub => {
                const exists = output.some(
                    u => u.urlType === UrlTypes.CATEGORY_HUB && u.pathname === hub.pathname
                );
                // inject if not already present
                if (!exists) {
                    output.push({
                        ...hub,
                        lastmod: '',    // sitemap fields (could be filled later)
                        changefreq: '',
                        priority: '',
                        isSitemap: false, // indicate non-sitemap-generated entry
                    });
                }
            });
        });

    return output;
}